const USER_ID_STORAGE_KEY = 'speach_user_id'

/**
 * Returns a stable user ID for the current browser tab session.
 * Persists across page refreshes via sessionStorage so that
 * LiveKit recognizes the reconnecting user as the same participant
 * (preventing duplicate "ghost" users after a page reload).
 */
export function getOrCreateUserId(): string {
  const stored = sessionStorage.getItem(USER_ID_STORAGE_KEY)
  if (stored) return stored

  const id = generateUserId()
  sessionStorage.setItem(USER_ID_STORAGE_KEY, id)
  return id
}

/**
 * Generates a unique user ID using crypto.randomUUID
 */
function generateUserId(): string {
  return crypto.randomUUID()
}
